var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pi-widget-pi-echart-line"},[_c('div',{ref:"echartLine",staticClass:"echart-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }